import type { SearchTerminalContext } from "@wags/discovery/index.ts";
import { searchNavigationContextSchema } from "./search-navigation-context.contract.ts";

const browserRuntimeId = crypto.randomUUID();

export function createSearchNavigationContext(context: SearchTerminalContext) {
    return { runtimeId: browserRuntimeId, context };
}

export function resolveSearchNavigationContext(
    state: object | null | undefined,
): SearchTerminalContext | null {
    if (state === null || state === undefined) return null;
    const parsed = searchNavigationContextSchema.safeParse(
        Reflect.get(state, "searchCorrelation"),
    );
    if (!parsed.success || parsed.data.runtimeId !== browserRuntimeId)
        return null;
    return parsed.data.context;
}

export function createObservedSearchContext({
    query,
    source = "url",
    action = "navigation",
}: {
    query: string;
    source?: SearchTerminalContext["submissionSource"];
    action?: SearchTerminalContext["action"];
}): SearchTerminalContext {
    return {
        searchInteractionId: crypto.randomUUID(),
        queryRevision: query.length > 0 ? 1 : 0,
        submissionId: crypto.randomUUID(),
        query,
        submissionSource: source,
        action,
        surface: "web",
    };
}

export function shouldRecordFindUrlSearchSubmission({
    isResultsMode,
    navigationContext,
    observedContext,
}: {
    isResultsMode: boolean;
    navigationContext: SearchTerminalContext | null;
    observedContext: SearchTerminalContext;
}): boolean {
    return (
        isResultsMode &&
        navigationContext === null &&
        observedContext.submissionSource === "url" &&
        observedContext.action === "navigation"
    );
}
